// extracted by mini-css-extract-plugin
export default {"group":"balance_group__IWuRE","title":"balance_title__j02LO","totals":"balance_totals__bj0Cg"};